import {
	canvasSizeCoefficient,
	margin,
} from './constants';

export const calculateSpinningWheelSize = () => {
	const wheelSize = window.innerHeight * canvasSizeCoefficient;
	const center = wheelSize / 2;

	return {
		size: wheelSize,
		center,
		radius: center - margin,
	};
};
